__webpack_require__.p = "/handsart-physio-and-rehab/";